module.exports = __webpack_public_path__ + "assets/cross-icon.5b135735.svg";